const PERMISSION_KEY= "personalize:nebula_ultra_log";
const PAGE_URL = {
    NEBULA_ULTRA_LOG_PAGE: "/admin/personalize/nebula-ultra-log"
}

export {PERMISSION_KEY, PAGE_URL}


